<template>
    <div class="w-full h-full min-h-700px">
      <iframe
        :src="iframeSrc"
        :style="iframeStyle"
        frameborder="0"
        allow="microphone"
        class="w-full h-full"
      ></iframe>
    </div>
  </template>
  
  <script setup>
  const iframeSrc = 'https://dify.triz1.com/chatbot/cMEiYuRJmlj0uzkE';
  const iframeStyle = {
    width: '96%',
    height: '100%',
    minHeight: '850px',
    margin:'55px 30px'
  };
  </script>
  
  <style scoped>
  /* 可根据需要添加额外样式 */
  </style>
      